'use strict';
module.exports = cb => new Promise(resolve => {
	resolve(cb());
});



//////////////////
// WEBPACK FOOTER
// ./~/p-try/index.js
// module id = 988
// module chunks = 0